import { useEffect, useState } from "react";
import Loader from "../../utilities/Loader/Loader";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import useAuth from "../../../hooks/useAuthContext";
import { getCountries, getStatesByCountry, getCitiesByState } from "../../../utils/getLocation";

export default function PersonalDetail({personalDetail, fetchUserProfile}) {
  const {userData, fetchUserDetails} = useAuth()

  const [formData, setFormData] = useState({
    'title': '',
    'first_name': '',
    'last_name': '',
    'middle_name': '',
    'country': '',
    'state': '',
    'city': '',
    'address': '',
    'dob': '',
    'phone': '',
    'alternate_phone': ''
  })
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [validationError, setValidationError] = useState({})
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const {name, value} = e.target

    setFormData(prevFormData => (
      {...prevFormData, [name]: value}
    ))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    setValidationError({})
    formData.email = userData?.userInfo?.email
    axiosInstance.post('/user/profile', formData)
              .then(res => {
                toast.success(res.data.message)
                fetchUserDetails()
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
                if(err.response.status == 422) {
                  setValidationError(err.response.data.errors)
                }
              })
              .finally(() => setLoading(false))
  }

  useEffect(() => {
    setFormData({
      'title': personalDetail?.title,
      'first_name': personalDetail?.first_name,
      'last_name': personalDetail?.last_name,
      'middle_name': personalDetail?.middle_name,
      'country': personalDetail?.country_id,
      'state': personalDetail?.state_id,
      'city': personalDetail?.city_id,
      'address': personalDetail?.address,
      'dob': personalDetail?.dob,
      'phone': personalDetail?.phone,
      'alternate_phone': personalDetail?.alternate_phone
    })
  }, [personalDetail])

  useEffect(() => {
    getCountries()
      .then(res => setCountries(res.data))
      .catch(err => console.log(err))
  }, [])

  useEffect(() => {
    if(formData.country) {
      getStatesByCountry(formData.country)
        .then(res => setStates(res.data))
        .catch(err => console.log(err))
    }
  }, [formData.country])

  useEffect(() => {
    if(formData.state) {
      getCitiesByState(formData.state)
        .then(res => setCities(res.data))
        .catch(err => console.log(err))
    }
  }, [formData.state])

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-lg-12">
          <div className="mb-3">
            <label htmlFor="title" className="form-label">
              Title
            </label>
            <select
              className="form-control"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
            >
              <option value="">-- Select Title --</option>
              <option value="mr">Mr.</option>
              <option value="mrs">Mrs.</option>
              <option value="dr">Dr.</option>
              <option value="prof">Prof.</option>
              <option value="pastor">Pastor.</option>
              <option value="deacon">Deacon.</option>
            </select>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="Surname" className="form-label">
              Surname
            </label>
            <input
              type="text"
              className="form-control"
              id="Surname"
              placeholder="Enter your Surname"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
            />
            {validationError.last_name && <small className="text-danger my-1"> 
              The Surname field is required
            </small>}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="firstnameInput" className="form-label">
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              id="firstnameInput"
              placeholder="Enter your firstname"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
            />
            {validationError.first_name && <small className="text-danger my-1"> {validationError.first_name[0]} </small>}
          </div>
        </div>
        {/* <!--end col--> */}
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="middlename" className="form-label">
              Middle Name
            </label>
            <input
              type="text"
              className="form-control"
              id="middlename"
              placeholder="Enter your middlename"
              name="middle_name"
              value={formData.middle_name}
              onChange={handleChange}
            />
          </div>
        </div>
        {/* <!--end col--> */}
        {/* <!--end col--> */}
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="dob" className="form-label">
              Date of Birth
            </label>
            <input
              type="date"
              className="form-control"
              id="dob"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
            />
            {validationError.dob && <small className="text-danger my-1"> {validationError.dob[0]} </small>}
          </div>
        </div>
        {/* <!--end col--> */}
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="phonenumberInput" className="form-label">
              Phone Number 1
            </label>
            <input
              type="text"
              className="form-control"
              id="phonenumberInput"
              placeholder="Enter your phone number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
        </div>
        {/* <!--end col--> */}
        {/* <!--end col--> */}
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="phonenumberInput2" className="form-label">
              Phone Number 2
            </label>
            <input
              type="text"
              className="form-control"
              id="phonenumberInput2"
              placeholder="Enter your phone number"
              name="alternate_phone"
              value={formData.alternate_phone}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-lg-4">
          <div className="mb-3">
            <label htmlFor="country" className="form-label">
              Country
            </label>
            <select
              className="form-control"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
            >
              <option value="">-- Select Country --</option>
              {countries.map(country => (
                <option key={country.id} value={country.id}>{country.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="mb-3">
            <label htmlFor="state" className="form-label">
              State
            </label>
            <select
              className="form-control"
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
            >
              <option value="">-- Select State --</option>
              {states.map(state => (
                <option key={state.id} value={state.id}>{state.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="mb-3">
            <label htmlFor="city" className="form-label">
              City
            </label>  
            <select
              className="form-control"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
            >
              <option value="">-- Select City --</option>
              {cities.map(city => (
                <option key={city.id} value={city.id}>{city.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="mb-3 pb-2">
            <label htmlFor="exampleFormControlTextarea" className="form-label">
              Residential Address
            </label>
            <textarea
              className="form-control"
              id="exampleFormControlTextarea"
              placeholder="Enter your address"
              rows="3"
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>
        </div>
        {/* <!--end col--> */}

        <div className="col-lg-12">
          <div className="hstack gap-2 justify-content-end">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
            {/* <button type="button" className="btn btn-soft-success">
              Cancel
            </button> */}
          </div>
        </div>
        {/* <!--end col--> */}
      </div>
      {loading && <Loader />}
      {/* <!--end row--> */}
    </form>
  );
}
